import modules from "./*.json";

const allItems = Object.keys(modules)
  .sort()
  .flatMap((key) => modules[key]?.items ?? []);

export default {
  items: allItems.map((item) => ({
    ...item,
    fileName: `mogrt/footage/generic/${item.fileName}`,
  })),
};
